import React, { FC } from 'react'
import Container from 'react-bootstrap/Container'

import {
    companyNameFull,
    preferedName,
    dataPortalTitle
} from '../../assets/i18n/i18n'

import PageTitle from '../PageTitle'

const NecessaryCookiesOnly: FC = () => {
    return (
        <section className='content'>
            <Container>
                <PageTitle displayName="Cookie Policy" />

                <h1 className='headerText h2'>Cookie Policy</h1>

                <p>
                    <strong>Effective Date:</strong> September 24, 2026
                    <br />
                    <strong>Date Last Updated:</strong> September 24, 2026
                </p>

                <h2 className='h3'>
                    1. Information About Our Use of Cookies
                </h2>

                <p>
                    The ConnectID {preferedName} {dataPortalTitle} is a secure
                    healthcare interoperability application operated by HealthLX
                    and {companyNameFull}. This Cookie Policy explains how
                    HealthLX, TESCHGlobal, and {companyNameFull}{' '}
                    (&quot;we&quot;, &quot;us&quot;, or &quot;our&quot;) use
                    cookies and similar technologies when you access this
                    application (collectively, the &quot;Service&quot;).
                </p>

                <p>
                    Cookies are small files stored on your browser when you visit
                    a website or sign in to an application. They allow the system
                    to recognize your browser during a session and remember
                    limited technical information necessary to operate the
                    Service.
                </p>

                <p>
                    We only use cookies that are required for the Service to
                    function securely. We do not use cookies to access files on
                    your device, monitor activity outside our services, or
                    perform advertising tracking.
                </p>

                <p>
                    Cookies may exist only while your browser is open (session
                    cookies) or for a limited defined period (persistent
                    cookies). The {preferedName} {dataPortalTitle} primarily
                    relies on secure session cookies.
                </p>

                <h2 className='h3'>2. Types of Cookies We Use</h2>

                <p>
                    We may use the following types of cookies on {preferedName}{' '}
                    {dataPortalTitle}:
                </p>

                <h3 className='h4'>Necessary Session Cookies</h3>

                <p>
                    The {preferedName} {dataPortalTitle} uses strictly necessary
                    cookies to provide secure access to the Service. These
                    cookies are automatically active because the application
                    cannot operate without them.
                </p>

                <p>
                    When you sign in, a temporary session identifier is created
                    that allows the Service to recognize your authenticated
                    session as you move between pages. Without this cookie, the
                    Service would treat every request as a new visit and you
                    would not be able to remain logged in.
                </p>

                <p>
                    These cookies support the following essential functions:
                </p>

                <ul>
                    <li>maintaining login authentication</li>
                    <li>enabling secure navigation between pages</li>
                    <li>enforcing inactivity timeouts</li>
                    <li>preventing unauthorized access</li>
                    <li>supporting security monitoring and audit logging</li>
                </ul>

                <p>
                    The cookie contains only a randomly generated session
                    reference. It does not contain any personal information or
                    login credentials. All sensitive information remains stored
                    securely on controlled servers and is never written to
                    browser cookies.
                </p>

                <p>
                    Session cookies automatically expire when you log out, close
                    your browser, or your session times out due to inactivity
                    and are not used for advertising or cross-site tracking
                    purposes.
                </p>

                <h3 className='h4'>Security Protection Cookies</h3>

                <p>
                    The {preferedName} {dataPortalTitle} uses additional
                    security cookies and tokens to protect users and the Service
                    from unauthorized activity. These mechanisms help verify
                    request authenticity and prevent misuse of authenticated
                    sessions. Security-related cookies and tokens are used
                    solely to protect account integrity, authenticate requests,
                    and assist in detecting unauthorized activity.
                </p>

                <p>They are used to:</p>

                <ul>
                    <li>validate legitimate application requests</li>
                    <li>prevent cross-site request forgery</li>
                    <li>detect suspicious activity patterns</li>
                    <li>maintain platform integrity</li>
                </ul>

                <p>
                    You may control cookie settings in your web browser to
                    refuse the setting of all or some cookies. If you use our
                    Service without changing your cookie settings, your
                    continued use of the Service following display of the
                    Cookie Policy constitutes acknowledgment of this Cookie
                    Policy. However, if you change your cookie settings to block
                    cookies, some features and functionality of our Service may
                    not operate as expected.
                </p>

                <p>
                    We may periodically update this Cookie Policy. Any revised
                    version will be posted through the Service with an updated
                    &quot;Date Last Updated&quot; date. Continued use of the
                    Service following publication of the revised Cookie Policy
                    constitutes acknowledgment of the updated Cookie Policy.
                </p>

                <h3 className='h4'>
                    Cookies to Enhance the User Experience
                </h3>

                <p>
                    The {preferedName} {dataPortalTitle} uses a persistent cookie
                    with a six month expiration to remember if you have agreed to the
                    cookie acknowledgement. Without this cookie, you would be prompted
                    each time. You can clear cookies in your browser at any time and
                    these will expire within six months and you will be prompted to
                    acknowledge again.
                </p>
            </Container>
        </section>
    )
}

export default NecessaryCookiesOnly